<template>
  <div class="app">
    <header class="app-header">
      <div
        class="app-header__burger"
        @click="toggleNavbar"
        :class="{
          burger_show: isShowNavbar,
        }"
      >
        <img src="@/assets/images/list.svg" alt="menu-svg" />
      </div>

      <div class="app-header__logo">
        <router-link to="/client/orders" class="app-header__link app-header__link_desktop">
          <img
            v-if="$config.project == 'profy'"
            src="@/assets/images/profy_logo.png"
            alt="logo"
            width="67px"
            height="28px"
          />
          <img v-else src="@/assets/images/onGreen.svg" alt="logo" />
        </router-link>
        <a :href="landingLink" target="_blank" c class="app-header__link app-header__link_mobile">
          <img
            v-if="$config.project == 'profy'"
            src="@/assets/images/profy_logo.png"
            alt="logo"
            width="67px"
            height="28px"
          />
          <img v-else src="@/assets/images/onGreen.svg" alt="logo" />
        </a>
        <a :href="landingLink" target="_blank" class="to-landing">
          {{
          $t("nav.landing")
          }}
        </a>
      </div>

      <div class="app-header__nav">
        <!-- <router-link class="btn btn_create-order ml10" tag="button" to="/client/orders/create">{{$t('buttons.create')}}</router-link> -->

        <app-languages />

        <router-link to="/client/profile" class="app-header__profile profile-menu" v-if="client">
          <div class="profile-menu__image">
            <img :src="getImage(client.big_image)" alt="profile" width="36px" height="36px" />
          </div>
          <div class="profile-menu__title">{{ client.first_name }} {{ client.last_name }}</div>
        </router-link>
      </div>
    </header>

    <div class="app-main">
      <div
        class="app-navbar"
        :class="{
          'app-navbar_show': isShowNavbar,
        }"
        :style="{
          height: pageHeight,
        }"
      >
        <div ref="menu-list" class="app-navbar__list">
          <div class="app-navbar__link">
            <router-link to="/client/orders/create">
              <img src="@/assets/images/clipboard.svg" width="24px" height="24px" alt />
              <span>{{ $t("createOrder.title") }}</span>
            </router-link>
          </div>
          <div class="app-navbar__link">
            <router-link to="/client/orders">
              <img src="@/assets/images/calendar.svg" alt />
              <span>{{ $t("nav.orders") }}</span>
            </router-link>
          </div>
          <!-- <div class="app-navbar__link">
            <router-link to="/client/chat">
              <img src="@/assets/images/message-empty-square.svg" width="24px" height="25px" alt />
              <span>Chat</span>
            </router-link>
          </div>-->
          <div class="app-navbar__link">
            <router-link to="/client/services">
              <img src="@/assets/images/services.svg" width="24px" height="25px" alt />
              <span>{{ $t("services.services") }}</span>
            </router-link>
          </div>
          <div class="app-navbar__link">
            <router-link to="/client/faq">
              <img src="@/assets/images/help-circle.svg" width="24px" height="25px" alt />
              <span>FAQ</span>
            </router-link>
          </div>

          <div class="app-navbar__terms">
            <ul>
              <li>
                <a @click="openLink(`${landingLink}/agb`, 'menu_termsOfUse')">
                  {{
                  $t("nav.termsOfUse")
                  }}
                </a>
              </li>
              <li>
                <a
                  @click="
                    openLink(`${landingLink}/datenschutz`, 'menu_privacyPolicy')
                  "
                >{{ $t("nav.privacy") }}</a>
              </li>
              <li>
                <a
                  @click="
                    openLink(`${landingLink}/impressum`, 'menu_impressum')
                  "
                >Impressum</a>
              </li>
            </ul>
            <span>v{{ appVersion }}</span>
          </div>
        </div>

        <div class="app-navbar__hide" @click="toggleNavbar"></div>
      </div>

      <div class="app-content">
        <transition name="fade">
          <router-view></router-view>
        </transition>
      </div>
    </div>

    <main-modal :show="mainModal" :className="`main-modal`" @close="closeModal">
      <order-modal />
    </main-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import image from "@/mixins/image";

import orderModal from "@/components/modals/orders/orderModal";
import mainModal from "@/components/modals/mainModal";
import socketio from "socket.io-client";
import appLanguages from "@/components/base/languages/appLanguages";
import { globalConfig } from "@/config";

import orders from "@/mixins/orders";

function getPageHeight() {
  return Math.max(document.body.scrollHeight, document.body.offsetHeight) - 70;
}

export default {
  name: "app-root",
  components: {
    mainModal,
    orderModal,
    appLanguages
  },
  mixins: [image, orders],
  data() {
    return {
      isShowNavbar: false,
      defaultImage: "/images/profile_photo.png",
      pageHeight: null,
      appVersion: globalConfig.appVersion
    };
  },
  computed: {
    ...mapGetters({
      mainModal: "main/mainModal",
      client: "client/client"
    }),
    landingLink() {
      return this.$config.project === "profy"
        ? "https://getprofy.de"
        : "https://hilfy.at";
    }
  },
  watch: {
    $route(v) {
      if (this.isShowNavbar) {
        this.toggleNavbar();
      }
      this.setPageHeight();
    }
  },
  methods: {
    ...mapMutations({
      setState: "main/setState",
      setStateAutocomplete: "autocomplete/setState",
      setNewMessage: "chat/setNewMessage",
      setStateChat: "chat/setState",
      setIsComponent: "orders/setIsComponent",
      setStateOrder: "orders/setState"
    }),
    ...mapActions({
      fetch: "client/fetch",
      fetchById: "orders/fetchById",
      active: "orders/active",
      fetchFiles: "orders/fetchFiles"
    }),
    openLink(link, event) {
      this.$log(event);
      window.open(link, "_blank");
    },
    toggleNavbar() {
      this.isShowNavbar = !this.isShowNavbar;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    closeModal() {
      this.setState({
        key: "mainModal",
        value: false
      });
    },
    init() {
      if (!this.client) return;

      const socket = socketio(this.$config.socketUrl, {
        transports: ["websocket"]
      });

      socket.on("connect", () => {
        socket.emit("init", { token: this.client.id });
      });

      const event = `messages.client.${this.client.id}:message.created`;

      socket.on(event, data => {
        this.$notify({
          title: this.$t("notifications.adminSentMessage"),
          message: this.$t("notifications.adminSentMessageText"),
          dangerouslyUseHTMLString: true,
          timeout: 5000
        });

        this.setNewMessage(data);
        this.setStateChat({
          key: "isNew",
          value: true
        });
      });

      socket.on("client.notifications:request.updated", async data => {
        console.log("client.notifications:request.updated");
        let order = localStorage.getItem("currentOrder");

        if (order == null) {
          setTimeout(() => {
            this.fetchOrdersMixin();
          }, 2000);
          return;
        }

        order = JSON.parse(order);
        if (data.request_id == order.id && order.status == "payment") {
          this.setState({
            key: "mainModal",
            value: false
          });

          localStorage.removeItem("currentOrder");
        }

        this.fetchOrdersMixin();
      });

      socket.on("client.notifications:payment.failed", async data => {
        this.setIsComponent("error");
      });
    },
    async showActiveOrder() {
      const order = await this.active();
      if (!order.should_started_at) return;

      this.setStateOrder({
        key: "isComponent",
        value: "mainView"
      });

      if (order == null) {
        return;
      }

      await this.fetchById(order.id);
      await this.fetchFiles(order.id);

      this.setState({
        key: "mainModal",
        value: true
      });
    },
    setPageHeight() {
      setTimeout(() => {
        this.pageHeight = `${getPageHeight()}px`;
      }, 1200);
    }
  },
  mounted() {
    this.fetch().then(() => {
      this.init();
    });

    this.showActiveOrder();
    this.setPageHeight();
  }
};
</script>

<style lang="scss">
.office-cat {
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  right: 0;
}

.to-landing {
  margin-left: 60px;
  color: #464646;
  text-underline-position: under;
  padding-bottom: 5px;
  display: inline-block;
}

.app {
  min-height: 100vh;
  width: 100%;
  overflow: hidden;

  &-languages {
    position: relative;
    margin: 0 12px;

    &__options {
      position: absolute;
      top: 0;
      z-index: 3;
    }
  }

  &-language-box {
    width: 48px;
    height: 48px;
    padding: 6px;
    background-color: #fff;
    position: relative;
    z-index: 2;
    visibility: hidden;
    border-radius: 0px 0px 4px 4px;

    &_current {
      visibility: visible;
    }
  }

  &-language {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1.6px solid #dc5b26;
    box-sizing: border-box;
    border-radius: 50%;
    font-size: 12px;
    font-weight: bold;
    color: #0c0c0c;
    cursor: pointer;
    transition: all 0.2s ease-in;

    &:hover {
      background: #dc5b26;
      color: #fff;
    }

    &_active {
      background: #dc5b26;
      color: #fff;
    }
  }

  &-main {
    display: flex;
    width: 100%;
    background-color: #f9f9f9;
    min-height: calc(100vh - 70px);
    margin-left: 200px;
    margin-top: 70px;
    overflow-x: hidden;
  }

  &-navbar {
    position: fixed;
    min-height: calc(100vh - 70px);
    left: 0;

    width: 200px;
    background: linear-gradient(180deg, #82c677 23.86%, #5b9351 100%), #ffffff;
    z-index: 2;

    &__logo {
      border-bottom: 1px solid #00000008;
      height: 71px;
    }

    &__link {
      a {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        width: 100%;
        text-decoration: none;
        padding: 30px 0 30px 36px;
        transition: all 0.3s linear;
        font-size: 16px;
        line-height: 18px;
        letter-spacing: 0.02em;
        color: #ffffff;

        img {
          display: inline-block;
          margin-right: 6px;
        }
        // &:hover {
        //     background-color: #0000001f;
        // }
      }
    }

    &__hide {
      width: 100%;
      height: 100%;
    }

    &_show {
      z-index: 4;
    }

    &__terms {
      position: absolute;
      bottom: 20px;
      left: 36px;

      ul {
        list-style-type: none;
        padding: 0;
        margin: 0;

        li {
          padding-bottom: 12px;
        }
      }

      a {
        color: #fff;
        font-size: 12px;
        transition: all 0.3s ease-in;
        &:hover {
          color: #f9f9f9;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      span {
        font-size: 12px;
        color: #fff;
      }
    }
  }

  &-header {
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    background: #ffffff;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);
    position: fixed;
    z-index: 3;

    &__burger {
      display: none;
    }

    &__link {
      display: flex;
      justify-content: center;

      &_mobile {
        display: none;
      }

      &_desktop {
        display: block;
      }
    }

    &__logo {
      display: flex;
      align-items: center;
      margin-left: 60px;

      a {
        background-color: #fff !important;
      }
    }

    &__nav {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      margin-left: auto;
      min-width: 272px;
    }

    &__profile {
      height: 100%;
      width: 100%;
      min-width: 200px;
      display: flex;
      align-items: center;
      padding: 0 18px;
      color: #4d4d4d;
      text-decoration: none;
      background: rgba(155, 205, 130, 0.15);
      box-sizing: border-box;

      img {
        display: inline-block;
        margin-right: 6px;
      }
    }
  }

  &-content {
    width: calc(100% - 200px);
    height: 100%;
    padding: 20px 56px;
  }
}

.profile {
  &-menu {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    transition: all 0.3s ease-out;

    &:hover {
      background-color: #0000001f;
    }

    &__image {
      margin-right: 5px;

      img {
        border-radius: 50%;
      }
    }

    &__title {
      font-size: 14px;
      color: #0c0c0c;
    }
  }
}

.main-modal {
  .modal-content {
    max-width: 645px;
    background-color: transparent;
  }
}

@media (max-width: 768px) {
  .to-landing {
    display: none;
  }

  .app-languages {
    right: 0;
    margin: 0 4px;
  }

  .app {
    &-navbar {
      width: 100%;
      position: absolute;
      left: -100%;
      transition: all 0.3s ease-out;
      min-height: 100vh;

      &__link a {
        padding: 24px 0 24px 20px;
        font-size: 14px;
      }

      &__logo {
        display: flex;
      }

      &_show {
        left: 0;
        background-color: #fff;
        height: 100%;
        max-width: 100%;
        overflow: auto;
        background: rgba(31, 50, 22, 0.9);
        display: flex;
      }

      &__list {
        background: linear-gradient(180deg, #82c677 23.86%, #5b9351 100%),
          #ffffff;
        max-width: 200px;
        width: 100%;
        min-height: 100vh;
      }

      &__logo {
        justify-content: center;
      }

      &__close {
        cursor: pointer;
        position: absolute;
        display: flex;
        align-items: center;
        right: 20px;
        height: 71px;
      }
    }

    &-header {
      &__profile {
        min-width: 60px;
        max-width: 60px;
      }

      &__burger {
        margin: 0 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.3s ease-out;
        cursor: pointer;
      }

      &__logo {
        margin-left: 0;
      }

      &__nav {
        height: 100%;
        margin-left: auto;
        min-width: 115px;
      }

      &__link {
        &_mobile {
          display: block;
        }

        &_desktop {
          display: none;
        }
      }
    }

    &-content {
      width: 100%;
      padding: 20px;
    }

    &-main {
      margin-left: 0;
    }
  }

  .profile {
    &-menu {
      &__title {
        display: none;
      }

      &__image {
        margin-right: 0;
      }
    }
  }

  .app-navbar_show .app-navbar__terms {
    position: relative;
    left: 20px;
    max-width: 90%;
    bottom: 0;
  }

  .app-languages {
    padding-top: 0;

    &__options {
      top: 0;
    }
  }
}

@media (max-width: 568px) {
  .app {
    &-content {
      padding: 20px 10px;
    }

    // &-header  {
    //     &__profile {
    //         width: 40%;
    //     }
    // }
  }

  .profile {
    &-menu {
      padding: 0;

      &__image {
        margin-right: 0;

        img {
          margin-right: 0;
        }
      }
    }
  }
}
</style>

<style>
.router-link-exact-active {
  background: rgba(12, 12, 12, 0.3);
}

.app-header .router-link-exact-active {
  background: rgba(155, 205, 130, 0.15);
}
</style>
